import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const GetStaffTurnoverRateRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().optional(),
  to: z.string().optional(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetStaffTurnoverRateResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  marketMedian: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
  isBetterThanMarket: z.boolean(),
});

export type GetStaffTurnoverRateRequestDto = z.infer<
  typeof GetStaffTurnoverRateRequestDtoSchema
>;

export type GetStaffTurnoverRateResponseDto = z.infer<
  typeof GetStaffTurnoverRateResponseDtoSchema
>;

export const getStaffTurnoverRate = async (
  params: GetStaffTurnoverRateRequestDto,
  config?: AxiosRequestConfig<GetStaffTurnoverRateRequestDto>
) => {
  const { facilityId, from, to, ...restParams } = params;

  // Transform dates to YYYY-MM format (backend expects month precision)
  const cleanParams = {
    ...Object.fromEntries(
      Object.entries(restParams).filter(([_, value]) => value !== undefined)
    ),
    ...(from && { from: from.slice(0, 7) }),
    ...(to && { to: to.slice(0, 7) }),
  };

  return api
    .get(`/market-intelligence/facilities/${facilityId}/staff-turnover-rate`, {
      params: cleanParams,
      ...config,
    })
    .then(responseContract(GetStaffTurnoverRateResponseDtoSchema));
};
